
    var riot = require('riot')
    
import vars from "vars"
riot.tag2('riot-tel', '<span if="{ua == &quot;pc&quot;}">{opts.tel}</span><span if="{ua == &quot;sp&quot;}"><a href="tel:{opts.tel}">{opts.tel}</a></span>', '', '', function(opts) {
    const self = this
    self.ua = "pc"

    $(function(){
      if( $("html").is(vars.uaset.sp) ){
        self.ua = "sp"
        self.update()
      }
    });
});
    
  


// WEBPACK FOOTER //
// ./_src/riot/riot-tel.tag